<div class="w-full ism-white">
  Native - A Race is considered "Native" to a star system when:<br />
  <ul>
    <li class="ml-14 ism-white">It has a population present in that Star System</li>
    <li class="ml-14 ism-white">It is a trade endpoint with another race</li>
    <li class="ml-14 ism-white">It is on a path between populations and/or a trade endpoint</li>
  </ul>
</div>

<div id="_stateFirstContact-CENTER_" class="my-2 px-2 text-1.25 w-1/2 flex flex-col border overlay-dark-30">
  <div class="flex flex-col">
    <div>Player Race First Contact Orders:</div>
    @if (informationRaceLocal() != null) {
      <table>
        <tr>
          <th>
            <label>{{ race()?.name }} is</label>
          </th>
          <th>
            <label>Capability</label>
          </th>
          <th>
            <label>Action</label>
          </th>
        </tr>
        <tr>
          <td>
            <label>--</label>
          </td>
          <td>
            <label>Low Tech</label>
          </td>
          <td>
            <select [(ngModel)]="informationRaceLocal().reactionOrderLowTech" class="ism-black">
              @for (instruction of responsesFirstContact; track instruction) {
                <option [ngValue]="instruction">{{ instruction }}</option>
              }
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <label>Native</label>
          </td>
          <td>
            <label>High Tech</label>
          </td>
          <td>
            <select [(ngModel)]="informationRaceLocal().reactionOrderNative" class="ism-black">
              @for (instruction of responsesFirstContact; track instruction) {
                <option [ngValue]="instruction">{{ instruction }}</option>
              }
            </select>
          </td>
        </tr>
        <tr>
          <td>
            <label>Non Native</label>
          </td>
          <td>
            <label>High Tech</label>
          </td>
          <td>
            <select [(ngModel)]="informationRaceLocal().reactionOrderNonNative" class="ism-black">
              @for (instruction of responsesFirstContact; track instruction) {
                <option [ngValue]="instruction">{{ instruction }}</option>
              }
            </select>
          </td>
        </tr>
        <tr>
          <td colspan="2" align="right">
            <button class="mx-2 px-4 btn" type="button" (click)="saveInformationRaceData(informationRaceLocal())">Save General</button>
          </td>
        </tr>
      </table>
    }
  </div>
</div>
